import { Tooltip, Typography } from '@mui/material';

import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router-dom';

import Carousel from 'react-material-ui-carousel';

import { saveUserRecentActivity } from 'common/api';
import { appPages } from 'common/constants/TextContent';
import { truncateString, urlWithTenant } from 'common/utils/utilFunctions';

import { getRecentViewedRegulations } from '../api';
import { IRecentViewedRegulationData } from '../api/type-def';

import { rightcarosuel, leftcarosuel } from '../../../../common/assets/images';
import rightIcon from '../../../../common/assets/images/right-chevron-circle-white.svg';
import { ENTITY_TYPE } from '../../../../common/constants/TaxonomyConstants';
import { RootState } from '../../../../common/store/AppStore';

import styles from './RecentlyViewed.module.scss';

export const dateInCorrectFormatWithFullYear = (time: string) => {
	const date = new Date(time);
	const formattedDate = date.toLocaleString('en-US', {
		month: '2-digit',
		day: '2-digit',
		year: 'numeric',
	});
	const formattedTime = date.toLocaleString('en-US', {
		hour: 'numeric',
		minute: 'numeric',
		hour12: true,
	});

	const correctTime = `${formattedDate} at ${formattedTime}`;

	return correctTime;
};

const RecentlyViewed = () => {
	const [visible, setVisible] = useState<string>('hidden');
	const [showRecentlyView, setShowRecentlyView] = useState<boolean>(false);
	const [recentlyViewed, setRecentlyViewed] = useState<
		IRecentViewedRegulationData[]
	>([]);
	const [groupedRegulations, setGroupedRegulations] = useState<
		IRecentViewedRegulationData[][]
	>([]);

	const { highlightedBubble } = styles;
	const navigate = useNavigate();
	const loggedInUser = useSelector(
		(state: RootState) => state.common.loggedInUser,
	);
	const { REG_CHANGE_PAGE } = appPages;

	const recentViewedRegulations = async () => {
		const userEmail = loggedInUser?.userId ?? '';
		const resp = await getRecentViewedRegulations({ userId: userEmail });
		if (resp) {
			setRecentlyViewed(resp?.responseBody ?? []);
			setShowRecentlyView(true);
		} else {
			setShowRecentlyView(false);
		}
	};
	const navigationToCitationDetail = async (
		entityId: string,
		officeName: string,
		entityType: string,
	) => {
		const now = new Date();
		const formattedTime = now.toISOString();
		const payload = {
			entityName: officeName,
			entityId,
			userId: loggedInUser?.userId as string,
			entityOperation: 'READ',
			operationTimestamp: formattedTime,
			entityType,
		};

		const bodyData = { ...payload };
		const responseFromApi = await saveUserRecentActivity(bodyData);
		if (responseFromApi) {
			navigate(urlWithTenant(`/regulation-change/${entityId}`), {
				state: {
					...(entityType === ENTITY_TYPE.CITATION.toLowerCase()
						? { citationId: entityId, isCitationView: true }
						: { isCitationView: false }),
					entityName: officeName,
					routePath: REG_CHANGE_PAGE,
					entityType,
					entityId,
					displayLabel: REG_CHANGE_PAGE,
				},
			});
		}
	};

	useEffect(() => {
		recentViewedRegulations();
	}, []);

	useEffect(() => {
		if (recentlyViewed.length > 3) {
			setVisible('visible');
		}
		if (recentlyViewed.length > 0) {
			const regulationGroupedArray: IRecentViewedRegulationData[][] = [];

			for (let i = 0; i < recentlyViewed.length; i += 3) {
				regulationGroupedArray.push(recentlyViewed.slice(i, i + 3));
			}
			setGroupedRegulations(regulationGroupedArray);
		}
	}, [recentlyViewed]);

	return (
		<div>
			{showRecentlyView && (
				<div className={styles.head} data-testid="recent-view-page">
					<div className={styles['recently-viewed-regulation']}>
						Recently viewed
					</div>
					<Carousel
						NextIcon={<img src={rightcarosuel} alt="Next Icon" />}
						PrevIcon={
							<img
								src={leftcarosuel}
								alt="Next Icon"
								data-testid="NavigateNextIcon"
							/>
						}
						navButtonsWrapperProps={{
							className: styles['carousel-nav-btn'],
						}}
						indicatorContainerProps={{
							className: styles['carousel-indicator'],
						}}
						navButtonsAlwaysVisible
						sx={{
							opacity: 1,
							color: highlightedBubble,
							'& .css-hn784z': {
								visibility: visible,
							},
							'& .css-1abc02a': {
								visibility: visible,
								// marginRight:'90px',
							},
							'& .MuiSvgIcon-root': {
								visibility: visible,
							},
						}}
						className={styles['custom-carousel']}
						autoPlay={false}
						animation="slide"
					>
						{groupedRegulations.map(
							(regulationSet: IRecentViewedRegulationData[], i: number) => (
								<div
									className={styles['card-row']}
									data-testid="regulation-set"
									key={groupedRegulations[i][0].modifiedDate}
								>
									{regulationSet.map((data: IRecentViewedRegulationData) => (
										<Typography sx={{ flex: 1 }} key={data.entityId}>
											<div
												className={styles['card-style']}
												data-testid="recent-card"
											>
												<Typography className={styles['regulation-card']}>
													{data.entityName.length > 30 ? (
														<Tooltip title={data.entityName}>
															<span>{`${truncateString(
																data.entityName,
																30,
															)}...`}</span>
														</Tooltip>
													) : (
														data.entityName
													)}
												</Typography>
												<img
													role="presentation"
													src={rightIcon}
													alt="svg-icon"
													className={styles['right-icon']}
													onClick={() => {
														navigationToCitationDetail(
															data.entityId,
															data.entityName,
															data.entityType,
														);
													}}
													data-testid="navigate-icon"
												/>
											</div>
											<Typography className={styles['last-seen']}>
												{dateInCorrectFormatWithFullYear(data.modifiedDate)}
											</Typography>
										</Typography>
									))}
								</div>
							),
						)}
					</Carousel>
				</div>
			)}
		</div>
	);
};
export default RecentlyViewed;
